import type { CmsItem } from '~/types/cms';

export function useLocationRouteTarget(entry: CmsItem) {
    const { locale } = useI18n();
    const slugMap = useLocalizedSlug(entry);

    return {
        name: 'locations-slug',
        params: {
            slug: slugMap[locale.value]?.slug ?? entry.slug
        }
    };
}
